import controllerFullName from "./controller_full_name.js";

const bodyOverflowAuto = (controller) => {
  const controllerName = controllerFullName(controller);
  if (document.body.dataset.bodyOverflowHiddenBy !== controllerName) {
    return;
  }
  delete document.body.dataset.bodyOverflowHiddenBy;
  document.body.style.overflow = 'auto';
}
const bodyOverflowHidden = (controller) => {
  if (!document.body.dataset.bodyOverflowHiddenBy) {
    document.body.style.overflow = 'hidden';
    document.body.dataset.bodyOverflowHiddenBy = controllerFullName(controller);
  }
}

export {bodyOverflowAuto, bodyOverflowHidden}